module.exports = __webpack_public_path__ + "img/save.42028629.svg";